import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { CounterPattern } from './models';

const importDataService = {
  get(): Promise<CommonResponse<Array<CounterPattern>>> {
    const url = `/counter-patterns`;
    return axiosClient.get(url);
  },
  update(params: Array<CounterPattern>): Promise<CommonResponse<null>> {
    const url = `/counter-patterns`;
    return axiosClient.put(url, params);
  },
  importData(params: FileList): Promise<CommonResponse<null>> {
    const url = `/upload-csv`;
    const formData = new FormData();
    for (let i = 0; i < params.length; i++) {
      formData.append('files', params[i]);
    }
    return axiosClient.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default importDataService;
